import { useSearchParams } from 'react-router-dom';
import { Shell } from '../components/Shell';

export function MagicLinkSentPage() {
  const [params] = useSearchParams();
  const email = params.get('email') || 'your inbox';
  return (
    <Shell centerLabel="Check your inbox · Step 1 of 4">
      <section className="border-b" style={{ borderColor: 'var(--rule)' }}>
        <div className="max-w-[720px] mx-auto px-6 md:px-14 py-24 text-center">
          <div
            style={{
              width: 60,
              height: 44,
              border: '1.5px solid var(--ink)',
              borderRadius: 3,
              position: 'relative',
              margin: '0 auto 22px',
            }}
            aria-hidden
          >
            <div
              style={{
                position: 'absolute',
                left: 0,
                width: 30,
                height: '1.5px',
                background: 'var(--ink)',
                top: 18,
                transformOrigin: 'left center',
                transform: 'rotate(33deg)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                right: 0,
                width: 30,
                height: '1.5px',
                background: 'var(--ink)',
                top: 18,
                transformOrigin: 'right center',
                transform: 'rotate(-33deg)',
              }}
            />
          </div>
          <h1 className="font-medium mb-4" style={{ fontSize: 'clamp(28px, 3.4vw, 40px)', lineHeight: 1.04, letterSpacing: '-0.03em' }}>
            Check your inbox.
          </h1>
          <p className="text-[15px] leading-[1.55] max-w-[520px] mx-auto" style={{ color: 'rgba(13,11,31,0.7)' }}>
            We sent a sign-in link to <strong>{email}</strong>. Open it to continue. The link expires in 1 hour and can only be used once.
          </p>
          <p className="meta mt-8" style={{ color: 'var(--muted-ink)' }}>
            Wrong email? <a href="/signup" className="underline" style={{ color: 'var(--ink)' }}>Try again</a>
          </p>
        </div>
      </section>
    </Shell>
  );
}
